/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsOffersMortgageLoanOffer {
    

    loanOfferGuid?: string;

    termYears?: number;

    monthlyPayment?: number;

    interestRate?: number;

    apr?: number;

    pointPercent?: number;

    cashToClose?: number;

    loanAmount?: number;

    category?: LDCLPBPPublicApiModelsLoanApplicationsOffersMortgageLoanOffer.CategoryEnum;

    mortgageLoanOfferFees?: models.LDCLPBPPublicApiModelsLoanApplicationsOffersMortgageLoanOfferFees;

    monthlyExpenses?: models.LDCLPBPPublicApiModelsPricingMortgageHousingExpenseSummary;

    closingCosts?: number;

    prePaidFees?: number;

    costsPaidBySeller?: number;

    specialProgramFees?: number;

    principalAndInterestMonthly?: number;

    pitiMonthly?: number;

    pointsPaid?: number;

    loanFees?: number;

    estimatedAccruedInterest?: number;

    currentLoanBalance?: number;

    lockTerm?: number;

    canLock?: boolean;

    zeroOutOfPocket?: boolean;

    pricingDetails?: models.LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse;

    coreLogicRecordId?: string;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsOffersMortgageLoanOffer {

    export enum CategoryEnum { 
        Unknown = <any> 'Unknown',
        PurchaseConventionalFixed30 = <any> 'PurchaseConventionalFixed30',
        PurchaseConventionalFixed25 = <any> 'PurchaseConventionalFixed25',
        PurchaseConventionalFixed20 = <any> 'PurchaseConventionalFixed20',
        PurchaseConventionalFixed15 = <any> 'PurchaseConventionalFixed15',
        PurchaseConventionalFixed10 = <any> 'PurchaseConventionalFixed10',
        PurchaseConventionalARM10_1 = <any> 'PurchaseConventionalARM10_1',
        PurchaseConventionalARM7_1 = <any> 'PurchaseConventionalARM7_1',
        PurchaseConventionalARM5_1 = <any> 'PurchaseConventionalARM5_1',
        RefinanceConventionalFixed30 = <any> 'RefinanceConventionalFixed30',
        RefinanceConventionalFixed25 = <any> 'RefinanceConventionalFixed25',
        RefinanceConventionalFixed20 = <any> 'RefinanceConventionalFixed20',
        RefinanceConventionalFixed15 = <any> 'RefinanceConventionalFixed15',
        RefinanceConventionalFixed10 = <any> 'RefinanceConventionalFixed10',
        RefinanceConventionalARM10_1 = <any> 'RefinanceConventionalARM10_1',
        RefinanceConventionalARM7_1 = <any> 'RefinanceConventionalARM7_1',
        RefinanceConventionalARM5_1 = <any> 'RefinanceConventionalARM5_1',
        PurchaseVAFixed30 = <any> 'PurchaseVAFixed30',
        PurchaseVAFixed25 = <any> 'PurchaseVAFixed25',
        PurchaseVAFixed20 = <any> 'PurchaseVAFixed20',
        PurchaseVAFixed15 = <any> 'PurchaseVAFixed15',
        PurchaseVAFixed10 = <any> 'PurchaseVAFixed10',
        PurchaseVAARM5_1 = <any> 'PurchaseVAARM5_1',
        PurchaseVAARM3_1 = <any> 'PurchaseVAARM3_1',
        RefinanceVAFixed30 = <any> 'RefinanceVAFixed30',
        RefinanceVAFixed25 = <any> 'RefinanceVAFixed25',
        RefinanceVAFixed20 = <any> 'RefinanceVAFixed20',
        RefinanceVAFixed15 = <any> 'RefinanceVAFixed15',
        RefinanceVAFixed10 = <any> 'RefinanceVAFixed10',
        RefinanceVAARM5_1 = <any> 'RefinanceVAARM5_1',
        RefinanceVAARM3_1 = <any> 'RefinanceVAARM3_1',
        PurchaseFHAFixed30 = <any> 'PurchaseFHAFixed30',
        PurchaseFHAFixed25 = <any> 'PurchaseFHAFixed25',
        PurchaseFHAFixed20 = <any> 'PurchaseFHAFixed20',
        PurchaseFHAFixed15 = <any> 'PurchaseFHAFixed15',
        PurchaseFHAFixed10 = <any> 'PurchaseFHAFixed10',
        PurchaseFHAARM5_1 = <any> 'PurchaseFHAARM5_1',
        PurchaseFHAARM3_1 = <any> 'PurchaseFHAARM3_1',
        RefinanceFHAFixed30 = <any> 'RefinanceFHAFixed30',
        RefinanceFHAFixed25 = <any> 'RefinanceFHAFixed25',
        RefinanceFHAFixed20 = <any> 'RefinanceFHAFixed20',
        RefinanceFHAFixed15 = <any> 'RefinanceFHAFixed15',
        RefinanceFHAARM3_1 = <any> 'RefinanceFHAARM3_1',
        PurchaseJumboFixed30 = <any> 'PurchaseJumboFixed30',
        PurchaseJumboFixed25 = <any> 'PurchaseJumboFixed25',
        PurchaseJumboFixed20 = <any> 'PurchaseJumboFixed20',
        PurchaseJumboFixed15 = <any> 'PurchaseJumboFixed15',
        PurchaseJumboFixed10 = <any> 'PurchaseJumboFixed10',
        PurchaseJumboARM10_1 = <any> 'PurchaseJumboARM10_1',
        PurchaseJumboARM7_1 = <any> 'PurchaseJumboARM7_1',
        PurchaseJumboARM5_1 = <any> 'PurchaseJumboARM5_1',
        RefinanceJumboFixed30 = <any> 'RefinanceJumboFixed30',
        RefinanceJumboFixed25 = <any> 'RefinanceJumboFixed25',
        RefinanceJumboFixed20 = <any> 'RefinanceJumboFixed20',
        RefinanceJumboFixed15 = <any> 'RefinanceJumboFixed15',
        RefinanceJumboFixed10 = <any> 'RefinanceJumboFixed10',
        RefinanceJumboARM10_1 = <any> 'RefinanceJumboARM10_1',
        RefinanceJumboARM7_1 = <any> 'RefinanceJumboARM7_1',
        RefinanceJumboARM5_1 = <any> 'RefinanceJumboARM5_1',
    }
}
